// extracted by mini-css-extract-plugin
module.exports = {"container":"baseLayout_container__15ln6","content":"baseLayout_content__1FqCE","callMeContent":"baseLayout_callMeContent__11GxN","hasRTCContent":"baseLayout_hasRTCContent__YcMSl"};